import { createI18n } from 'vue-i18n';
import da from '@/locales/da.json';
import enGb from '@/locales/en-GB.json';
import enUs from '@/locales/en-US.json';
import frCa from '@/locales/fr-CA.json';

export const DEFAULT_LOCALE = 'en-GB' as const;

export const messages = {
  da,
  'en-GB': enGb,
  'en-US': enUs,
  'fr-CA': frCa,
};

export type SupportedLocale = keyof typeof messages;

export const i18n = createI18n({
  legacy: false,
  locale: DEFAULT_LOCALE as string,
  fallbackLocale: DEFAULT_LOCALE,
  messages,
});

export const t = i18n.global.t;

export function updateLocale(locale: SupportedLocale = DEFAULT_LOCALE): void {
  i18n.global.locale.value = locale as typeof i18n.global.locale.value;
}
